import { Component, EventEmitter, Input, OnChanges, Optional, Output, SimpleChanges } from '@angular/core';
import { Category, Option } from '@telespot/protocols/data-access';

@Component({
    selector: 'ts-label-context-menu',
    templateUrl: './label-context-menu.component.html',
    styleUrls: ['./label-context-menu.component.scss'],
    standalone: false
})
export class LabelContextMenuComponent implements OnChanges {
  @Input() categories: Record<string, Category> = {};
  @Input() options: Record<string, Option> = {};

  @Input() @Optional() checkedOptions: string[] = [];
  @Input() @Optional() doubleCheckedOptions: string[] = [];

  @Output() optionSelected = new EventEmitter<string>();
  @Output() optionDeselected = new EventEmitter<string>();
  @Output() optionHovered = new EventEmitter<string>();
  @Output() optionUnhovered = new EventEmitter<string>();

  public categoryArray = [];

  public ngOnChanges(changes: SimpleChanges): void {
    for (const key in changes) {
      const { currentValue, previousValue } = changes[key];

      if (currentValue === previousValue) continue;

      switch (key) {
        case 'categories':
          this.categoryArray = Object.values(currentValue ?? {});
          break;
        default:
          break;
      }
    }
  }

  public isDoubleChecked(option: string): boolean {
    return this.doubleCheckedOptions.includes(option);
  }

  public isChecked(option: string): boolean {
    return this.checkedOptions.includes(option) && !this.isDoubleChecked(option);
  }

  public toggle(option: string) {
    if (this.isDoubleChecked(option)) return this.optionDeselected.emit(option);

    this.optionSelected.emit(option);
  }
}
